export function useMailSuffix(): string {
    return `@${import.meta.env.VITE_VUE_APP_SITE_NAME.toLowerCase()}`
}
